import { render, staticRenderFns } from "./BalancePanel.vue?vue&type=template&id=43586c1c&scoped=true&"
import script from "./BalancePanel.vue?vue&type=script&lang=ts&"
export * from "./BalancePanel.vue?vue&type=script&lang=ts&"
import style0 from "./BalancePanel.vue?vue&type=style&index=0&id=43586c1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43586c1c",
  null
  
)

export default component.exports